var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseBody",
    [
      _c(
        "BaseTopBar",
        [
          _c("BaseTopBarContent", { attrs: { className: "left pr-0" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("sidebar.serialnumber")) +
                " > " +
                _vm._s(_vm.serialSingle.serCode) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("BaseTopBarContent", { attrs: { className: "right pl-0" } }, [
            !_vm.loading
              ? _c(
                  "div",
                  { staticClass: "action" },
                  [
                    _vm.device.isMobile
                      ? [
                          _c("BaseActionDropdown", {
                            attrs: {
                              icon: "fas fa-cog",
                              text: _vm.$t("button.options"),
                              items: [
                                {
                                  icon: "fas fa-copy",
                                  iconClassName: "",
                                  text: _vm.$t("button.clone"),
                                  textClassName: "",
                                  value: "clone"
                                },
                                {
                                  icon: "fas fa-trash",
                                  iconClassName: "text-danger",
                                  text: _vm.$t("button.delete"),
                                  textClassName: "text-danger",
                                  value: "delete"
                                }
                              ]
                            },
                            on: { onSelect: _vm.handleSelectOption }
                          })
                        ]
                      : [
                          _vm.hasRoleDelete
                            ? _c("BaseActionDropdown", {
                                attrs: {
                                  icon: "fas fa-cog",
                                  text: _vm.$t("button.options"),
                                  items: [
                                    {
                                      icon: "fas fa-trash",
                                      iconClassName: "text-danger",
                                      text: _vm.$t("button.delete"),
                                      textClassName: "text-danger",
                                      value: "delete"
                                    }
                                  ]
                                },
                                on: { onSelect: _vm.handleSelectOption }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("BaseAction", {
                            attrs: {
                              icon: "fas fa-copy",
                              iconClassName: "",
                              text: _vm.$t("button.clone"),
                              textClassName: ""
                            },
                            on: { onClick: _vm.openCloneModal }
                          })
                        ],
                    _vm._v(" "),
                    [
                      _vm.loadingStatus
                        ? _c("div", { staticClass: "dropdown nodro item" }, [
                            _c("i", { staticClass: "fas fa-spinner spin" })
                          ])
                        : [
                            _vm.hasRoleEdit
                              ? _c("BaseActionDropdown", {
                                  attrs: {
                                    className: _vm.statusColor,
                                    text: _vm.statusText,
                                    items: [
                                      {
                                        text: _vm.$t(
                                          "apps.inventory.message.serialready"
                                        ),
                                        textClassName: "text-success",
                                        value: true,
                                        disabled: _vm.isEmpty
                                      },
                                      {
                                        text: _vm.$t(
                                          "apps.inventory.message.serialnotready"
                                        ),
                                        textClassName: "text-warning",
                                        value: false,
                                        disabled: _vm.isEmpty
                                      }
                                    ]
                                  },
                                  on: { onSelect: _vm.handleSelectStatus }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.hasRoleEdit
                              ? _c("div", { staticClass: "dropdown item" }, [
                                  _c("span", { class: [_vm.statusColor] }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.statusText) +
                                        "\n              "
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ]
                    ]
                  ],
                  2
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BaseContent",
        { attrs: { loading: _vm.loading } },
        [
          _c("WrapperDoc", {
            scopedSlots: _vm._u([
              {
                key: "form",
                fn: function() {
                  return [
                    _c("ImsSerialNumberForm", {
                      attrs: {
                        state: _vm.serialSingle,
                        serCode: _vm.serialSingle.serCode,
                        isSubmitted: _vm.isSubmitted,
                        warehouses: _vm.warehouses,
                        products: _vm.products,
                        disabled: _vm.disabledForm,
                        form: _vm.form,
                        showActionButtons: !_vm.disabledForm
                      },
                      on: {
                        "update:form": function($event) {
                          _vm.form = $event
                        },
                        onSubmit: _vm.handleSubmit
                      }
                    }),
                    _vm._v(" "),
                    _c("baseConfirmDeleteModal", {
                      attrs: {
                        show: _vm.modal.show,
                        loading: _vm.modal.loading
                      },
                      on: {
                        onClose: _vm.handleCloseModal,
                        onCancel: _vm.handleCancleModal,
                        onSubmit: _vm.handleSumitModal
                      }
                    }),
                    _vm._v(" "),
                    _c("BaseConfirmDiscardModal", {
                      attrs: { show: _vm.confirmDiscardModal.show },
                      on: {
                        onCancel: _vm.handleDiscardCancleModal,
                        onConfirm: _vm.handleDiscardConfirmModal
                      }
                    }),
                    _vm._v(" "),
                    _c("BaseConfirmCloneModal", {
                      attrs: {
                        show: _vm.modalConfirmClone.show,
                        loading: _vm.modalConfirmClone.loading
                      },
                      on: {
                        onClose: _vm.handleCloseCloneModal,
                        onCancel: _vm.handleCancleCloneModal,
                        onConfirm: function($event) {
                          return _vm.handleConfirmCloneModal({
                            payload: _vm.payloadClone,
                            createApiFn: _vm.createSerial,
                            redirectTo: "InventorySerialList",
                            refCode: "ser_code"
                          })
                        }
                      }
                    })
                  ]
                },
                proxy: true
              },
              {
                key: "ref",
                fn: function() {
                  return [
                    _c("DocRef", {
                      attrs: {
                        refDoc: "ser",
                        refId: _vm.serialSingle.serId,
                        refCode: _vm.serialSingle.serCode,
                        showLog: _vm.getInventorySetting.log_topic.is_active,
                        showAttachFile:
                          _vm.getInventorySetting.attach_file.is_active,
                        logTopics: _vm.getInventorySetting.log_topic.options,
                        isSubmitted: _vm.isSubmitted
                      }
                    })
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4008de88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4008de88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/serialnumber/Edit.vue
// module id = null
// module chunks = 